import { mapValues } from 'lodash';
import { matchPath } from 'react-router';

import viewFlows from './views';

const currentFlows = {};

export const fetchingMiddleware = (action, next) => {
  if (action.name === '_updateLocation') {
    const { pathname } = action.args[0];
    const currentMatches = mapValues(viewFlows, (_, route) =>
      matchPath(pathname, {
        path: route,
        exact: viewFlows[route].exact !== false,
        strict: false
      })
    );
    const currentTasksKeys = Object.keys(currentMatches).filter(key => currentMatches[key]);

    //abort pending requests
    const tasksToAbortKeys = Object.keys(currentFlows).filter(route => !currentTasksKeys.includes(route));
    for (let i = 0; i < tasksToAbortKeys.length; i++) {
      const taskKey = tasksToAbortKeys[i];
      if (viewFlows[taskKey].abort) {
        viewFlows[taskKey].abort({ action });
      }
      delete currentFlows[taskKey];
    }

    for (let i = 0; i < currentTasksKeys.length; i++) {
      const currentTaskKey = currentTasksKeys[i];

      // prevent restart of the task on search change
      if (currentFlows[currentTaskKey]) {
        continue;
      }

      const task = viewFlows[currentTaskKey];
      const match = currentMatches[currentTaskKey];

      if (task) {
        currentFlows[currentTaskKey] = true;
        task.call({ action, match });
      }
    }
  }
  next(action);
};
